/* Foldora additions for Impact: delivery date line, add-on checkbox, secondary "Add to bag" buttons. */
(function () {
  if (window.FoldoraTheme) return;
  window.FoldoraTheme = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }

  /* "Order today, arrives by [date]" — re-runs whenever Impact re-renders the product info. */
  class FdDeliveryDate extends HTMLElement {
    connectedCallback() {
      const template = this.getAttribute('data-template') || this.textContent.trim();
      this.setAttribute('data-template', template);
      if (template.indexOf('[date]') === -1) return;
      const now = new Date();
      const cutoff = Number(this.dataset.cutoff);
      let start = now;
      if (now.getHours() >= cutoff || now.getDay() === 0 || now.getDay() === 6) start = addBusinessDays(now, 1);
      const arrive = addBusinessDays(start, Number(this.dataset.max) || 4);
      let label;
      try {
        label = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { weekday: 'short', day: 'numeric', month: 'short' }).format(arrive);
      } catch (e) {
        label = arrive.toDateString();
      }
      const parts = template.split('[date]');
      const strong = document.createElement('strong');
      strong.textContent = label;
      this.replaceChildren(parts[0], strong, parts.slice(1).join(''));
    }
  }
  if (!customElements.get('fd-delivery-date')) customElements.define('fd-delivery-date', FdDeliveryDate);

  /* Add-on checkbox: once Impact adds the watch, add the ticked add-on and refresh the cart. */
  document.addEventListener('variant:add', async (event) => {
    const form = event.target && event.target.closest ? event.target.closest('form') : null;
    if (!form || !form.id) return;
    const boxes = Array.from(document.querySelectorAll('[data-fd-addon][data-form="' + form.id + '"]:checked'));
    if (!boxes.length) return;
    const added = (event.detail && event.detail.items ? event.detail.items : []).map((i) => String(i.variant_id || i.id));
    const items = boxes
      .map((b) => b.getAttribute('data-fd-addon'))
      .filter((id) => added.indexOf(String(id)) === -1)
      .map((id) => ({ id: Number(id), quantity: 1 }));
    if (!items.length) return;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      });
      if (res.ok) boxes.forEach((b) => { b.checked = false; });
    } finally {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  });

  /* Extra "Add to bag" buttons (FAQ section) submit the main product form with the chosen variant. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fd-trigger-add]');
    if (!trigger) return;
    const form = document.querySelector('form[is="product-form"][id^="product-form-"]');
    if (!form) return;
    const submit = Array.from(form.elements).find((el) => el.type === 'submit');
    if (!submit || submit.disabled) {
      (submit || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      submit.click();
    }
  });
})();
